<template>
  <div class="container">
    <contact-bar></contact-bar>
    <navigation-bar></navigation-bar>
    <div class="level is-mobile pt-6 pb-0">
      <div class="level-item level-right has-text-right">
        <svg-icon
          class="has-text-yellow"
          type="mdi"
          :path="mdiMenuLeft"
          style="width: 50px; height: 50px"
        ></svg-icon>
        <svg-icon
          class="has-text-yellow"
          type="mdi"
          :path="mdiMenuRight"
          style="width: 50px; height: 50px"
        ></svg-icon>
      </div>
    </div>
    <div class="block pb-6">
      <h1
        class="has-text-left has-text-primary"
        :class="width < 768 ? 'is-size-3' : 'is-size-1'"
        style="font-family: Calibri; font-weight: bold"
      >
        {{ currentEquipo?.nombre }}
      </h1>
      <h1
        class="has-text-left has-text-green"
        :class="width < 768 ? 'is-size-3' : 'is-size-1'"
        style="font-family: Calibri"
      >
        {{ currentEquipo?.codigo }}
      </h1>
    </div>
  </div>
  <figure class="image">
    <img
      class="has-ratio"
      :src="currentEquipo?.imgShowRoom"
      :alt="currentEquipo?.alt"
    />
  </figure>
  <div class="container pb-6">
    <div class="block">
      <p
        class="has-text-justified has-text-primary is-size-6 pt-6 pb-6"
        style="font-family: Calibri; font-weight: bold"
      >
        {{ currentEquipo?.descripcion }}
      </p>
    </div>
    <div class="pb-6">
      <figure class="image is-16by9">
        <iframe
          width="640"
          height="360"
          class="has-ratio"
          :src="'https://www.youtube.com/embed/' + currentEquipo?.video"
          frameborder="0"
          allowfullscreen
        ></iframe>
      </figure>
    </div>
    <div class="block pt-6" style="background-color: #40587d">
      <div class="columns level">
        <div
          class="column level-left is-three-quarters-desktop is-three-quarters-tablet is-three-quarters-widescreen is-three-quarters-fullhd is-full-mobile is-mobile"
          style="padding-left: 3rem; padding-right: 3rem"
        >
          <h2 class="has-text-white is-size-4" style="font-family: Calibri">
            TE INVITAMOS A OPTIMIZAR TUS PROCESOS DE SELLADO CON EL APOYO DE
            EXPERTOS EN LA INDUSTRIA
          </h2>
          <p
            class="has-text-white is-size-6 is-mobile pt-2 pb-6"
            style="font-family: Calibri; font-weight: bold"
          >
            Nuestros ingenieros están a tu disposición para entender tus
            desafíos y ofrecerte orientación. Solicita una llamada o reunión hoy
            mismo.
          </p>
        </div>
        <div
          class="column level-rigth is-one-quarter-desktop is-one-quarter-widescreen is-one-quarter-fullhd is-one-quarter-tablet is-full-mobile is-mobile pb-6 has-text-centered"
        >
          <button
            class="button has-text-white is-normal has-background-yellow"
            style="font-family: Calibri; font-weight: bold; border: none"
          >
            CHATEA CON NOSOTROS
          </button>
        </div>
      </div>
    </div>
    <div class="block">
      <h1
        class="has-text-centered has-text-primary pt-6"
        :class="width < 768 ? 'is-size-3' : 'is-size-1'"
        style="font-family: Calibri; font-weight: bold"
      >
        LO MAS IMPORTANTE
      </h1>
      <div class="columns">
        <div class="column">
          <ul>
            <li class="p-4" v-for="(item, index) in featuresLeft" :key="index">
              <p
                class="has-text-primary is-size-5"
                style="font-family: Calibri; font-weight: bold"
              >
                <svg-icon
                  type="mdi"
                  :path="mdiCheckboxMarkedCircle"
                  style="color: #38ac61; vertical-align: text-bottom"
                ></svg-icon
                >{{ " " + item.titulo }}
              </p>
              <p
                class="has-text-primary is-size-6 pl-6"
                style="font-family: Calibri"
              >
                {{ item.descripcion }}
              </p>
            </li>
          </ul>
        </div>
        <div class="column">
          <ul>
            <li class="p-4" v-for="(item, index) in featuresRigth" :key="index">
              <p
                class="has-text-primary is-size-5"
                style="font-family: Calibri; font-weight: bold"
              >
                <svg-icon
                  type="mdi"
                  :path="mdiCheckboxMarkedCircle"
                  style="color: #38ac61; vertical-align: text-bottom"
                ></svg-icon
                >{{ " " + item.titulo }}
              </p>
              <p
                class="has-text-primary is-size-6 pl-6"
                style="font-family: Calibri"
              >
                {{ item.descripcion }}
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="block pt-6">
      <div class="columns level">
        <div
          class="column is-mobile level-left is-three-quarters-desktop is-three-quarters-tablet is-three-quarters-fullhd is-three-quarters-widescreen is-full.mobile"
        >
          <p class="has-text-primary is-size-5" style="font-family: Calibri">
            EXTRAS DISPONIBLES: CORTADORAS Y CODIFICADORES.
          </p>
        </div>
        <div
          class="column is-mobile level-rigth is-one-quarter-desktop is-one-quarter-tablet is-one-quarter-fullhd is-one-quarter-widescreen has-text-right-desktop has-text-right-widescreen has-text-right-fulhd has-text-right-tablet has-text-centered-mobile is-full-mobile"
        >
          <button
            class="button has-text-white is-normal has-background-yellow"
            style="font-family: Calibri; font-weight: bold; border: none"
          >
            DESCARGA LA FICHA TÉCNICA
          </button>
        </div>
      </div>
    </div>
  </div>
  <figure class="image is-16by9">
    <img
      class="has-ratio"
      src="../assets/selladora_web_02.jpg"
      alt="selladora_web_02.jpg"
    />
  </figure>
  <div class="container">
    <div class="block pb-6">
      <h1
        class="has-text-centered has-text-primary pt-6"
        :class="width < 768 ? 'is-size-3' : 'is-size-1'"
        style="font-family: Calibri; font-weight: bold"
      >
        NUESTRA EXPERIENCIA Y BUEN SERVICIO HACEN LA DIFERENCIA
      </h1>
      <p
        class="has-text-primary is-size-6 has-text-justified pt-4"
        style="font-family: Calibri; font-weight: bold"
      >
        Tenemos el conocimiento y la experiencia integrando selladoras de bolsas
        en una amplia gama de industrias. Estamos aquí para escucharte y
        ayudarte a encontrar la mejor solución para tus necesidades. A la hora
        de elegir una selladora de bolsas muchos factores entran en juego, desde
        el tipo de bolsa, la cantidad a envasar por minuto, el tipo de producto,
        entre otros. Alcanza tus objetivos seleccionando el equipo correcto. ¡No
        esperes más, contáctanos ahora!
      </p>
      <p
        class="has-text-primary is-size-5 has-text-justified pt-5"
        style="font-family: Calibri; font-weight: bold"
      >
        MANOS A LA OBRA
      </p>
      <p
        class="has-text-primary is-size-6 has-text-justified"
        style="font-family: Calibri; font-weight: bold"
      >
        Llena el formulario y un asesor se pondrá en contacto contigo.
      </p>
      <form class="pt-5">
        <div class="field">
          <div class="control">
            <input class="input" placeholder="Nombre" type="text" />
          </div>
        </div>
        <div class="field">
          <div class="control">
            <input class="input" placeholder="Apellido" type="text" />
          </div>
        </div>
        <div class="field">
          <div class="control">
            <input class="input" placeholder="Empresa" type="text" />
          </div>
        </div>
        <div class="field">
          <div class="control">
            <input class="input" placeholder="E-mail" type="email" />
          </div>
        </div>
        <div class="field">
          <div class="control">
            <input class="input" placeholder="Teléfono" type="phone" />
          </div>
        </div>
        <div class="field">
          <div class="control">
            <div class="select" style="width: 100%">
              <select
                v-model="formaContacto"
                style="width: 100%"
                :style="formaContacto == '' ? 'color: lightGray' : ''"
              >
                <option class="has-text-gray" disabled selected value="">
                  Forma de contacto
                </option>
                <option value="whatsapp">WhatsApp</option>
                <option value="email">E-mail</option>
                <option value="llamada">Llamada</option>
              </select>
            </div>
          </div>
        </div>
        <div class="field">
          <div class="control">
            <input class="input" placeholder="País" type="text" />
          </div>
        </div>
        <div class="field">
          <div class="control">
            <input class="input" placeholder="Estado" type="text" />
          </div>
        </div>
        <div class="field">
          <div class="control">
            <input class="input" placeholder="Comentarios" type="text" />
          </div>
        </div>
        <div class="field">
          <div class="control">
            <label class="checkbox">
              <input type="checkbox" />
              Acepto <a href="#">Términos y condiciones</a> y
              <a href="#">Aviso de privacidad</a>
            </label>
          </div>
        </div>
        <div class="field is-grouped is-grouped-centered">
          <div class="control">
            <button
              class="button has-background-yellow has-text-white"
              style="width: 15rem"
            >
              ENVIAR
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <contact-media></contact-media>
  <div class="container">
    <equipos-carrusel
      clasification="todos"
      label="OTROS EQUIPOS"
    ></equipos-carrusel>
  </div>
  <footer-component></footer-component>
</template>
<script setup lang="ts">
import ContactBar from "@/components/ContactBar.vue";
import NavigationBar from "@/components/NavigationBar.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import { useEquipos } from "@/use-equipos";
import SvgIcon from "@jamescoyle/vue-icon";
import EquiposCarrusel from "@/components/EquiposCarrusel.vue";
import ContactMedia from "@/components/ContactMedia.vue";
import { mdiCheckboxMarkedCircle, mdiMenuLeft, mdiMenuRight } from "@mdi/js";
import { ref } from "vue";
import { useWindowSize } from "vue-window-size";

const { width } = useWindowSize();

const { currentEquipo, initialize } = useEquipos();
initialize();
const featuresLength = currentEquipo.value?.features.length || 0;
const featuresLeft = currentEquipo.value?.features.slice(0, featuresLength / 2);
const featuresRigth = currentEquipo.value?.features.slice(
  featuresLength / 2,
  featuresLength
);
let formaContacto = ref("");
</script>
